// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select__container,
.Select__form-control {
  width: 100%;
}

.Select__form-control.Select__form-control--disabled {
  background-color: var(--palette-gray-7-opacity12);
}

.Select__form-control.Select__form-control .Select__label,
.Select__form-control.Select__form-control .Select__select {
  padding-left: 0.85rem;
  padding-bottom: 0.76rem;
}

.Select__form-control.Select__form-control
  label.Select__label.Select__label--shrink {
  padding-left: calc(0.85rem / 0.75);
}

.Select__form-control label:not(.Select__label--shrink) {
  transform: translate(0px, 2.14rem) scale(1);
}

.Select__form-control label.Select__label--shrink {
  transform: translate(0px, 0.57rem) scale(0.75);
}

.Select__form-control label {
  font-weight: normal;
}

.Select__form-control label + .Input__container {
  margin-top: 1.49rem;
  padding-top: 0.11rem;
  padding-bottom: 0.11rem;
}

.Select__form-control.Select__form-control .Select__select:focus {
  background-color: inherit;
}

.Select__form-control label.Select__label--focused {
  color: var(--palette-trovit-blue);
}

.Select__form-control
  .Input__container.Input__container--underline.Input__container:not(.Input__container--disabled):not(.Input__container--focused):not(.Input__container--focused)::before {
    border-bottom-color: var(--palette-disabled);
  }

.Select__form-control
  .Input__container.Input__container--underline.Input__container:not(.Input__container--disabled):not(.Input__container--focused):not(.Input__container--focused):hover::before {
  border-bottom-color: var(--palette-trovit-blue);
}

.Select__SelectOption:hover,
.Select__SelectOption.Select__SelectOption--selected {
  color: var(--palette-trovit-blue);
}

.Select__Paper .Select__SelectOption.Select__SelectOption--selected,
.Select__Paper .Select__SelectOption.Select__SelectOption:focus:not(:hover) {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/input/Select/Select.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;AACb;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;IAEI,4CAA4C;EAC9C;;AAEF;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;AAClB","sourcesContent":[".Select__container,\n.Select__form-control {\n  width: 100%;\n}\n\n.Select__form-control.Select__form-control--disabled {\n  background-color: var(--palette-gray-7-opacity12);\n}\n\n.Select__form-control.Select__form-control .Select__label,\n.Select__form-control.Select__form-control .Select__select {\n  padding-left: 0.85rem;\n  padding-bottom: 0.76rem;\n}\n\n.Select__form-control.Select__form-control\n  label.Select__label.Select__label--shrink {\n  padding-left: calc(0.85rem / 0.75);\n}\n\n.Select__form-control label:not(.Select__label--shrink) {\n  transform: translate(0px, 2.14rem) scale(1);\n}\n\n.Select__form-control label.Select__label--shrink {\n  transform: translate(0px, 0.57rem) scale(0.75);\n}\n\n.Select__form-control label {\n  font-weight: normal;\n}\n\n.Select__form-control label + .Input__container {\n  margin-top: 1.49rem;\n  padding-top: 0.11rem;\n  padding-bottom: 0.11rem;\n}\n\n.Select__form-control.Select__form-control .Select__select:focus {\n  background-color: inherit;\n}\n\n.Select__form-control label.Select__label--focused {\n  color: var(--palette-trovit-blue);\n}\n\n.Select__form-control\n  .Input__container.Input__container--underline.Input__container:not(.Input__container--disabled):not(.Input__container--focused):not(.Input__container--focused)::before {\n    border-bottom-color: var(--palette-disabled);\n  }\n\n.Select__form-control\n  .Input__container.Input__container--underline.Input__container:not(.Input__container--disabled):not(.Input__container--focused):not(.Input__container--focused):hover::before {\n  border-bottom-color: var(--palette-trovit-blue);\n}\n\n.Select__SelectOption:hover,\n.Select__SelectOption.Select__SelectOption--selected {\n  color: var(--palette-trovit-blue);\n}\n\n.Select__Paper .Select__SelectOption.Select__SelectOption--selected,\n.Select__Paper .Select__SelectOption.Select__SelectOption:focus:not(:hover) {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
